import { t } from 'i18next';

import useAuth from '@/hooks/useAuth';

import Constants from '@/constants';

import { convertDateForReports, isDateExpired } from './date';

import { PersonCourseReportDto } from '@/_generated/api-clients/xp';

export const getCompletionDate = (teamMember: PersonCourseReportDto) => {
  if (
    teamMember.certificate &&
    isDateExpired(teamMember.certificate.expiration)
  ) {
    return t('Generic.notInCompliance');
  }

  const coursePassed = (
    [
      Constants.TRAINING_PLANS_STATUSES.PASSED,
      Constants.TRAINING_PLANS_STATUSES.COMPLETED,
    ] as string[]
  ).includes(teamMember.courseStatus ?? '');

  if (
    (!teamMember.certificate && !coursePassed) ||
    !teamMember.courseCompletionDate
  ) {
    return t('Generic.notInCompliance');
  }

  if (!teamMember.certificate && !teamMember.courseStatus) {
    return t('Generic.na');
  }

  return convertDateForReports(teamMember.courseCompletionDate);
};

export const useMultipleReportsTabsEnabled = () => {
  const { data } = useAuth();

  const isAtLeastLeader =
    (data?.allLocationsWithAtLeastLeaderPermissions.length ?? 0) > 0;
  const features = data?.features;
  const hasMultipleReportingTabs =
    !!features?.reporting?.plans?.enabled &&
    (!!features.reporting.teamMember?.enabled ||
      !!features.reporting.compliance?.enabled);

  return isAtLeastLeader && hasMultipleReportingTabs;
};
